"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var source_filter_html_1 = __importDefault(require("@components/filters/custom-filters/source-filter.html"));
(function (module) {
    module.factory('prSourceFilterDirectiveLinker', [
        '$q',
        '$timeout',
        'prFieldsets',
        'prSourceDataService',
        function ($q, $timeout, fieldsets, sourceData) {
            var PAGINATION_LIMIT = 100;
            var operatorTranslations = {
                in: 'FSFILTERS.IS',
                notIn: 'FSFILTERS.IS_NOT',
                isEmpty: 'FSFILTERS.IS_EMPTY',
                isNotEmpty: 'FSFILTERS.IS_NOT_EMPTY'
            };
            var Linker = function (_$rootScope, _$fcFilter, _$scope) {
                var _this = this;
                this.$rootScope = _$rootScope;
                this.$fcFilter = _$fcFilter;
                this.$scope = _$scope;
                this.getSourceInfoMapCache = [];
                this.$scope.template = function () {
                    return source_filter_html_1.default;
                };
                var operatorMenu = _.map(operatorTranslations, function (translateKey, value) {
                    return {
                        label: _this.$fcFilter('fcTranslate')(translateKey),
                        value: value
                    };
                });
                $timeout(function () {
                    // timeout is needed to wait for the template scope to be defined
                    _this.$templateScope = _this.$scope.$$childHead;
                    angular.extend(_this.$templateScope, {
                        operatorMenu: operatorMenu,
                        onSelection: _this.onSelection.bind(_this),
                        updateFilter: _this.updateFilter.bind(_this),
                        getOperands: _this.getOperands.bind(_this),
                        operator: _this.$scope.displayedFilter.filter.operator,
                        getOperatorLabel: _this.getOperatorLabel.bind(_this),
                        getOperandLabel: _this.getOperandLabel.bind(_this),
                        isOperandDisabled: _this.isOperandDisabled.bind(_this),
                        pagination: {
                            limit: PAGINATION_LIMIT
                        }
                    });
                });
            };
            Linker.prototype.onSelection = function (value, selected) {
                var existingOperand = this.$scope.displayedFilter.filter.operand || [];
                if (selected) {
                    this.updateFilter(existingOperand.concat([value]));
                }
                else {
                    this.updateFilter(_.without(existingOperand, value));
                }
            };
            Linker.prototype.updateFilter = function (value) {
                var _this = this;
                $timeout(function () {
                    _this.$scope.displayedFilter.filter.operator = _this.$templateScope.operator;
                    _this.$scope.displayedFilter.filter.operand = value;
                    _this.$rootScope.$broadcast('filterChanged');
                });
            };
            Linker.prototype.isOperandDisabled = function () {
                return _.includes(['isEmpty', 'isNotEmpty'], this.$templateScope.operator);
            };
            Linker.prototype.getOperatorLabel = function () {
                return operatorTranslations[this.$templateScope.operator];
            };
            Linker.prototype.getOperandLabel = function () {
                var operand = this.$scope.displayedFilter.filter.operand;
                if (!operand || !operand.length) {
                    return this.$fcFilter('fcTranslate')('FSFILTERS.SELECT_OPERAND');
                }
                else if (operand.length > 1) {
                    return operand.length + ' ' + this.$fcFilter('fcTranslate')('FSFILTERS.SELECTED');
                }
                if (this.getSourceInfoMapCache && !_.isEmpty(this.getSourceInfoMapCache)) {
                    return this.getSourceInfoMapCache[operand[0]].name;
                }
                this.getSourceInfoMap();
                return operand[0];
            };
            Linker.prototype.getOperands = function (search) {
                var _this = this;
                var operand = this.$scope.displayedFilter.filter.operand;
                return this.getSourceInfoMap().then(function (sourceInfoMap) {
                    if (!sourceInfoMap || !_.keys(sourceInfoMap).length) {
                        return [{
                                label: _this.$fcFilter('fcTranslate')('FSFILTERS.NO_AVAILABLE_FIELDS'),
                                disabled: true
                            }];
                    }
                    var header = [{
                            header: true,
                            label: _this.$fcFilter('fcTranslate')('FSFILTERS.SELECT_ONE_OR_MORE_FIELDS')
                        }, {
                            divider: true
                        }];
                    var menuItems = _.values(sourceInfoMap).map(function (sourceInfo) {
                        if (search && search.length > 1) {
                            search = _.toLower(search);
                            if (!_.includes(_.toLower(sourceInfo.id), search) &&
                                !_.includes(_.toLower(sourceInfo.name), search)) {
                                return;
                            }
                        }
                        return {
                            value: sourceInfo.id,
                            label: sourceInfo.name,
                            selected: _.includes(operand, sourceInfo.id)
                        };
                    });
                    return header.concat(_.compact(menuItems));
                });
            };
            Linker.prototype.getSourceInfoMap = function () {
                var _this = this;
                if (this.getSourceInfoMapCache && !_.isEmpty(this.getSourceInfoMapCache)) {
                    return $q.when(this.getSourceInfoMapCache);
                }
                return fieldsets.getMainFieldset().then(function (fieldset) {
                    var sources = fieldset.definition.sources;
                    var sourceIds = _.map(sources, 'id');
                    return sourceData.getUserSources(sourceIds);
                }).then(function (sourceInfo) {
                    _this.getSourceInfoMapCache = sourceInfo;
                    return sourceInfo;
                });
            };
            return Linker;
        }
    ]);
})(angular.module('qualtrics.pr'));
